<template>
	<div class="loading-spinner">
		<div class="loading-spinner-icon"></div>
	</div>
</template>
<script>
export default {
	name: "LoadingSpinner",
	components: {},
	computed: {},
	methods: {},
	mounted() {}
};
</script>